import {resolveOffering,type OfferingSource} from './offering';
/** Unspecified legacy offerings retain their existing studio; confirmed nonphysical offerings do not. */
export function allowsPhysicalProductStudio(brand?:OfferingSource|null,product?:OfferingSource|null){
 const {type}=resolveOffering(brand,product);return type!=='software'&&type!=='service';
}
